import {
    FETCH_JOB_LIST,
    RESET_JOB_LIST,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {
      total: 0,
      offset: 0,
      limit: 10,
    },
  };
  
  const jobListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_JOB_LIST:
        return { list: action.payload, others: action.others };
      case RESET_JOB_LIST:
        return initialState;
      default:
        return state;
    }
  };
  
  export default jobListReducer;
  